import { createFileRoute } from "@tanstack/react-router";
import { CrewListPage } from "~/pages/crew/CrewListPage";
export const Route = createFileRoute("/_authenticated/crew/")({ component: CrewListPage });
